import { render, staticRenderFns } from "./NoticeCentre.vue?vue&type=template&id=2334de2e&scoped=true&"
import script from "./NoticeCentre.vue?vue&type=script&lang=js&"
export * from "./NoticeCentre.vue?vue&type=script&lang=js&"
import style0 from "./NoticeCentre.vue?vue&type=style&index=0&id=2334de2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2334de2e",
  null
  
)

export default component.exports